/***************************************************************************

    LangMenuComponent.tsx
    -------------------------
    last Update          : August 12, 2025
    by                   : quentin.savoye@cil4sys.com
    copyright            : (C) 2025 by CIL4Sys Engineering 

***************************************************************************/

import { useStaticQuery, graphql } from "gatsby"
import { Link, useI18next } from "gatsby-plugin-react-i18next"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import window from "global"
import React from "react"
import { Dropdown, Nav } from "react-bootstrap"

import { AllFileType, AllStapiInterface } from "../../../types/types"

interface QueryData {
	allFile: AllStapiInterface<AllFileType>
}

interface Props {
	languages: Array<string>
	language: string
	originalPath: string
	queryData: QueryData
}

class LangMenuClassComponent extends React.Component<Props> {
	constructor(aProps: Props) {
		super(aProps)
	}

	public override render(): React.ReactNode {
		const currentEdge = this.props.queryData.allFile.edges.find((anEdge) => {
			return anEdge.node.name === this.props.language
		})

		return (
			<Dropdown as={Nav.Item} size="sm" className="lang-dropdown">
				<Dropdown.Toggle as={Nav.Link} style={{ paddingTop: "0px", paddingBottom: "0px" }}>
					<img className="language-flag-img" src={currentEdge?.node.publicURL} alt="" />
					<span className="text-uppercase language-flag-span"> {" | " + currentEdge?.node.name}</span>
				</Dropdown.Toggle>

				<Dropdown.Menu align={{ sm: "end" }} className="lang-dropdown-menu">
					{this.props.languages.map((aLng) => {
						return (
							<Dropdown.Item
								as={Link}
								key={aLng}
								// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
								to={this.props.originalPath + window.location?.hash}
								language={aLng}
								// onClick={() => setPos(anIndex)}
							>
								<img
									className="language-flag-img"
									src={this.props.queryData.allFile.edges.filter((anEdge) => anEdge.node.name === aLng)[0].node.publicURL}
									alt=""
								/>
								<span className="text-uppercase language-flag-span"> {" | " + aLng}</span>
							</Dropdown.Item>
						)
					})}
				</Dropdown.Menu>
			</Dropdown>
		)
	}
}

const langMenuComponent = (): JSX.Element => {
	const { languages, language, originalPath } = useI18next()
	const data = useStaticQuery<QueryData>(graphql`
		query MyLangQuery {
			allFile(filter: { relativeDirectory: { eq: "langFlags" } }) {
				edges {
					node {
						publicURL
						name
					}
				}
			}
		}
	`)

	return <LangMenuClassComponent language={language} languages={languages} originalPath={originalPath} queryData={data} />
}

export default langMenuComponent
